import { Chain } from "viem/chains";
import { getPublicClient } from "wagmi/actions";
import { Amount } from "../../types/amount";
import { TokenList } from "./getAllTokenLists";
import { cloneDeep } from "lodash-es";
import { getTokenDecimals, isAddressEqual } from "../../utils/tokenUtils";
import { Address, Hash } from "viem";
import { NATIVE_TOKEN_ADDRESS } from "config/consts";
import { getAbiToUse } from "utils/allowanceUtils";

export type MulticallResult = {
  tokenAddress: Address;
  result: Amount;
};

export type MulticallResults = Array<MulticallResult>;

export const getMulticallResult = async (
  tokens: TokenList,
  network: Chain,
  functionName: string,
  args: Array<string>
): Promise<MulticallResults> => {
  if (network && tokens) {
    const tokenAddresses = [...(Object.keys(tokens) as Array<Hash>)];
    const publicClient = getPublicClient({ chainId: network.id });
    const erc20TokenAddresses = tokenAddresses.filter(
      tokenAddress => !isAddressEqual(tokenAddress, NATIVE_TOKEN_ADDRESS)
    );
    const contracts = erc20TokenAddresses.map(address => ({
      address,
      abi: getAbiToUse(network, address),
      functionName,
      args,
    }));
    return publicClient
      .multicall({
        contracts: contracts,
      })
      .then(res => {
        const clonedTokens = cloneDeep(tokens);
        const failedCalls = res.filter(call => call.error);
        if (failedCalls.length > 0) {
          console.error(`${functionName} has failed calls`, failedCalls);
        }
        const balances: MulticallResults = [];
        res.forEach((call, index) => {
          if (call.error) {
            return;
          }
          const tokenDecimals = getTokenDecimals(erc20TokenAddresses[index], clonedTokens);
          const divisor = new Amount((10 ** tokenDecimals).toString());
          const result = call.result as bigint;
          const amount = new Amount(result.toString()).div(divisor);
          balances.push({ tokenAddress: erc20TokenAddresses[index], result: amount });
        });
        return balances;
      })
      .catch(err => {
        console.error(`${functionName} error`, err);
        return [];
      });
  }
  return [];
};
